import { render, staticRenderFns } from "./VideoTutorial.vue?vue&type=template&id=0af15898"
import script from "./VideoTutorial.vue?vue&type=script&lang=js"
export * from "./VideoTutorial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports